module.exports = __webpack_public_path__ + "static/media/CHANGELOG.c4ca17b3.md";